import { useEffect } from 'react';
import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import api from '../api';

const OnboardingTour = ({ user, role }) => {
    useEffect(() => {
        if (!user || user.has_seen_onboarding) return;

        const tourSteps = {
            pop: [
                {
                    element: '#profile-completion-card',
                    popover: {
                        title: 'Complete Your Profile',
                        description: 'This card shows your profile completion status. A higher percentage increases your visibility to universities.',
                        side: "bottom",
                        align: 'start'
                    }
                },
                {
                    element: '#availability-tab',
                    popover: {
                        title: 'Manage Availability',
                        description: 'Set your available time slots so students and universities can book sessions with you.',
                        side: "right",
                        align: 'start'
                    }
                },
                {
                    element: '#engagements-tab',
                    popover: {
                        title: 'Your Engagements',
                        description: 'Track all your active and past sessions with students and universities here.',
                        side: "right",
                        align: 'start'
                    }
                }
            ],
            student: [
                /* {
                    element: '#browse-professors',
                    popover: {
                        title: 'Discover Experts',
                        description: 'Browse through our network of industry experts and professors to find the right mentor for you.',
                        side: "bottom",
                        align: 'start'
                    }
                }, */
                {
                    element: '#book-session-button',
                    popover: {
                        title: 'Book a Session',
                        description: 'Found an expert? Click here to request a 1-on-1 or group session.',
                        side: "top",
                        align: 'center'
                    }
                },
                {
                    element: '#student-engagements-tab',
                    popover: {
                        title: 'Track Your Learning',
                        description: 'All your booked sessions and their status can be managed from this tab.',
                        side: "right",
                        align: 'start'
                    }
                }
            ],
            university: [
                {
                    element: '#post-requirement-button',
                    popover: {
                        title: 'Post Requirements',
                        description: 'Need an expert for a course or project? Post your requirements here to attract top talent.',
                        side: "bottom",
                        align: 'start'
                    }
                },
                {
                    element: '#manage-professors-tab',
                    popover: {
                        title: 'Manage Experts',
                        description: 'View and manage professors you are currently engaged with or those who have applied to your posts.',
                        side: "right",
                        align: 'start'
                    }
                },
                {
                    element: '#university-engagements-tab',
                    popover: {
                        title: 'Engagement Tracking',
                        description: 'Monitor the progress of all ongoing industry-academic collaborations.',
                        side: "right",
                        align: 'start'
                    }
                }
            ]
        };

        const driverObj = driver({
            showProgress: true,
            steps: tourSteps[role] || [],
            onDestroyed: async () => {
                try {
                    await api.patch('/users/me/onboarding-seen');
                    // Optional: Update local user state if needed, though usually a refresh or re-fetch on next mount handles it.
                } catch (error) {
                    console.error('Failed to update onboarding status:', error);
                }
            }
        });

        // Short delay to ensure elements are rendered
        const timer = setTimeout(() => {
            driverObj.drive();
        }, 1000);

        return () => clearTimeout(timer);
    }, [user, role]);

    return null;
};

export default OnboardingTour;


